import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import type BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import type { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import BordereauForceTraiteDGFIPAction from '../actions/BordereauForceTraiteDGFIPAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import BaseBordereauState from './BaseBordereauState';

class BordereauAcquitteState extends BaseBordereauState {
	constructor() {
		super();
		this.step = BordereauStateStep.ACQUITTE;
		this.state = BordereauStateType.ACQUITTE;
		this.color = '#14AE5C';
		this.libelle = 'Acquitté';
	}

	getBordereauActions(
		_bordereau: BordereauWithState,
		userRole: UserRole,
	): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
		return [
			new BordereauDupliquerAction(),
			...(userRole === UserRole.ADMIN
				? [
						new BordereauModifierAction({ isSuperUser: true }),
						new BordereauForceTraiteDGFIPAction({ isSuperUser: true }),
					]
				: []),
		];
	}

	getMouvementActions(
		userRole: UserRole,
	): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
		return [
			new MouvementModifierAction({ isReadonly: true }),
			new MouvementDupliquerAction(),
			...(userRole === UserRole.ADMIN
				? [new MouvementModifierAction({ isSuperUser: true })]
				: []),
		];
	}
}

export default BordereauAcquitteState;
